<template>
    <el-card class="mini-box-card box-d-card" >
        <template class="mini-card-header" #header>
            <span>Traveller Detail</span>
            <el-button class="white-btn" size="small" @click="edit = true;editdet()">Edit</el-button>
        </template>
        <h5>{{enquiry.name}}</h5>
        <ul class="ml-0 mb-0 fa-ul text-muted">

            <li class="small">Phone : {{enquiry.mobile}}</li>
            <li class="small">Email : {{enquiry.email_id}}</li>
            <li class="small">City : {{enquiry.city}}</li>
            <li class="small">State : {{enquiry.state}}</li>
            <li class="small" v-if="enquiry.lead_score !== null && enquiry.lead_score !== undefined">
                AI Score :
                <lead-score-badge
                    class="ml-1"
                    :score="enquiry.lead_score"
                    :type="enquiry.lead_score_type"
                    :label="enquiry.lead_score_label"
                />
            </li>

        </ul>
    </el-card>



    <el-drawer v-model="edit" direction="rtl">
        <template #header>
            <h4>Edit Traveller Detail</h4>
        </template>
        <template #default>
            <el-form
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >

                <el-form-item label="Name" prop="name">
                    <el-input  v-model="form.name" placeholder="Name" />

                </el-form-item>
                <el-form-item label="Phone" prop="mobile">
                    <CountryPhone v-model="form.mobile" @change="(n) => {form.mobile=n}" />
                </el-form-item>
                <el-form-item label="Email" prop="email_id">
                    <el-input  v-model="form.email_id" placeholder="Email" />

                </el-form-item>
                <el-form-item label="State" prop="state">
                    <el-select v-model="form.state" placeholder="Select" style="width: 100%" @change="statechange()" filterable>
                        <el-option v-for="state in states"  :value="state" >

                        </el-option>

                    </el-select>

                </el-form-item>
                <el-form-item label="City" prop="city">
                    <el-select v-model="form.city" placeholder="Select" style="width: 100%"  filterable>
                        <el-option v-for="city in cities"  :value="city" >

                        </el-option>

                    </el-select>

                </el-form-item>

            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="edit=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Save</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElCard,ElTag,ElRow,ElCol,ElButton,ElDrawer,ElForm,ElFormItem,ElInput,ElSelect,ElOption
} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import CountryPhone from './../../Items/CountryPhone';
import LeadScoreBadge from './LeadScoreBadge.vue';
const yourhandle= require('countrycitystatejson');
export default {
    name: "TravellerDetails",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { LeadScoreBadge, CountryPhone,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,Edit,ElDrawer,ElForm,ElFormItem,ElInput },
    data() {
        return {
            loading:false,
            edit:false,
            states:[],
            cities:[],
            form:{
                name:'',
                mobile:'',
                email_id:'',
                state:'',
                city:''
            },
            rules:{
                name: [
                    {
                        required: true, message: 'Enter Name',
                        trigger: ['blur','change'],
                    }
                ],
                mobile: [
                    {
                        required: true, message: 'Invalid Number',
                        trigger: ['blur','change'],
                    }
                ],
                state: [
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                city: [
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                email_id:[
                    {
                        required: true,
                        message: 'Required',
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: 'Please input correct email address',
                        trigger: ['blur', 'change'],
                    }
                ]
            }
        }
    },
    created(){
        var stateslist=yourhandle.getCountryByShort('IN');
        for (const key in stateslist.states) {
            this.states.push(key);
        }
    },
    methods:{
        editdet(){
            this.form.name=this.enquiry.name;
            this.form.mobile=this.enquiry.mobile;
            this.form.email_id=this.enquiry.email_id;
            this.form.city=this.enquiry.city;
            this.form.state=this.enquiry.state;

            if(this.enquiry.state!=""){
                this.cities=yourhandle.getCities('IN',this.enquiry.state);
            }
        },
        statechange(){
            this.form.city="";
            this.cities=yourhandle.getCities('IN',this.form.state);


        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.save()
                } else {
                    return false
                }
            })


        },
        save(){
            let currentObj = this;
            this.loading=true;
            axios.post('/saveenquirydetails?id='+this.enquiry.id,this.form).then(function (response) {


                toastr.success('Enquiry Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.loading=false;
                currentObj.edit=false;

            })
                .catch(function (error) {
                    toastr.error('Something Wrong try again.');
                });
        }
    }
}
</script>

<style scoped>

</style>
